import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarLocationDetails from "./component";
import { openLoginPopup } from "../../au.configuration/actions";
import withLogin from "../../au.desktop/with-login";
import { createClassifiedLead } from "../checkout-info/actions";
import { setShowHubLocationModal } from "../car-details/actions";

const mapStateToProps = (
    {
        carDetails: {
            cmsConfig,
            config,
            content,
            metaContent,
            showHubLocationModal,
            leadAppointment
        },
        user: {
            userGeoData,
            phoneNumberVerified,
            isLoggedIn
        },
        dealer: {
            dealerInfo
        }
    }
) => ({
    cmsConfig,
    config,
    content,
    userGeoData,
    metaContent,
    phoneNumberVerified,
    showHubLocationModal,
    leadAppointment,
    dealerInfo,
    isLoggedIn
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    openLoginPopupConnect: openLoginPopup,
    createClassifiedLeadConnect: createClassifiedLead,
    setShowHubLocationModalConnect: setShowHubLocationModal
}, dispatch);

export default withLogin(connect(mapStateToProps, mapDispatchToProps)(CarLocationDetails));
